onDomReady(() => {
   document.querySelector('.time-travel').style.display = 'flex';
   document.querySelector('.time-travel-placeholder').style.display = 'none';

   const dropdownWrapper = document.querySelector('.time-travel .dropdown-wrapper');
   const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
         if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
            let targetRevisionid = mutation.target.dataset.value;
            let url = new URL(window.location.href);
            url.searchParams.set('revisionid', targetRevisionid);
            window.location.href = url.toString();
         }
      });
   });
   observer.observe(dropdownWrapper, { attributes: true });
});
